module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction: “Caucasians” and the Political History of Racial Identities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("1 Before the “Caucasian Race”: Antecedents of European Racialism, ca. 1000–1684")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Enlightenment Science and the Invention of the “Caucasian Race,” 1684–1795")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Passage into “Our Ordinary Forms of Expression”: The “Caucasian Race,” ca. 1795–1850")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Racialized Nationalism and the Partial Eclipse of the “Caucasian Race,” ca. 1840–1935")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Color Line and the “Caucasian Race” Revival, 1935–51")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Not-so-Benign Racialism: The “Caucasian Race” after Decolonization, 1952–2005")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 “Where Caucasian Means Black”: “Race,” Nation, and the Chechen Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Deconstructing “Caucasia,” Dismantling Racism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0